import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import "./styles/Navbar.css";

const setRandomAnimationDelay = () => {
    document.querySelectorAll(".background-object").forEach((element) => {
        const randomDelay = Math.random() * -11; // Random delay between -4s and 0s
        element.style.animationDelay = `${randomDelay}s`;
    });
};

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation(); // Get the current path

    const { loginWithRedirect, logout, isAuthenticated } = useAuth0();
    const [fadeIn, setFadeIn] = useState(false);
    const [floating, setFloating] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [burgerActive, setBurgerActive] = useState(false);
    const [animateOut, setAnimateOut] = useState(false);
    const [activeButton, setActiveButton] = useState(location.pathname); // Set activeButton based on route

    useEffect(() => {
        setTimeout(() => setFadeIn(true), 1000); // Trigger fade-in after shrink animation
        setFloating(true); // Start floating effect
        setRandomAnimationDelay();

        // Function to check screen width and update showMenu
        const handleResize = () => {
            console.log("Window resized on path:", location.pathname);
            setBurgerActive(window.innerWidth <= 1000);
            setShowMenu(window.innerWidth > 1000);
        };

        // Attach resize event listener
        window.addEventListener("resize", handleResize);
        handleResize();

        // Cleanup event listener on component unmount
        return () => window.removeEventListener("resize", handleResize);
    }, [location.pathname]);

    useEffect(() => {
        setActiveButton(location.pathname); // Update active button when route changes
    }, [location.pathname]);

    const toggleMenu = () => {
        if (showMenu) {
            setAnimateOut(true); // Trigger reverse animation
            setTimeout(() => {
                setShowMenu(false); // Hide after animation duration (1s)
                setAnimateOut(false); // Reset animation state
            }, 500); // Match the animation duration
        } else {
            setShowMenu(true); // Show immediately
        }
    };

    return (
        <>
            {/* <div className="header-warning">
                <p>⚠️ Caution: 👀 You are viewing a site under development! 🛠️</p>
            </div> */}
            <div className={`home-page-logo-wrapper ${floating ? "floating" : ""}`} onClick={() => { navigate("/") }}>
                <img
                    className="home-page-logo"
                    src="/images/LoadingIntroBunny.png"
                    alt="Loading Bunny"
                />
            </div>
            <div className="menu-button" onClick={toggleMenu}>☰</div>
            {showMenu && (
                <div className={`buttons ${animateOut ? "smooth-fade-reverse" : "smooth-fade"}`}>
                    <div className="buttons-container">
                        <button
                            className={`services-button ${activeButton === "/services" ? "active" : ""}`}
                            onClick={() => {
                                navigate("/services");
                                setActiveButton("/services");

                                if (burgerActive) {
                                    setShowMenu(false);
                                }
                            }}
                        >
                            Services
                        </button>
                        <button
                            className={`policies-button ${activeButton === "/policies" ? "active" : ""}`}
                            onClick={() => {
                                navigate("/policies");
                                setActiveButton("/policies");

                                if (burgerActive) {
                                    setShowMenu(false);
                                }
                            }}
                        >
                            Policies
                        </button>
                        <button
                            className={`bookings-button ${activeButton === "/" ? "active" : ""}`}
                            onClick={() => {
                                navigate("/");
                                setActiveButton("/");

                                if (burgerActive) {
                                    setShowMenu(false);
                                }
                            }}
                        >
                            Book Now!
                        </button>
                        <button
                            className="logout-button"
                            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
                        >
                            Logout
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Navbar;
